import React, {useState} from 'react'
import ProgressBar from '../../../v2/atoms/ProgressBar'
import ImageDropArea from '../../../molecules/ImageDropArea-v1'
import * as image from '../../../helpers/Image'
import {uploadImage} from '../../../utils/galeryEvents'
import { Row, Col } from '../../../v2/atoms/Grid';
import Font from '../../../atoms/Font';
import css from './style.module.css'
import FontIcon from '../../../v2/atoms/FontIcon';
import Button from '../../../v2/atoms/Button';
import AspectRatio from '../../../v2/atoms/AspectRatio';
import ProcessList from '../../../v2/helpers/ProcessList';
import T from '../../../translate/T';

const Pl = new ProcessList(5)

function UploadImages (props) {
    const [files, setFiles] = useState([])
    const token = props.token

    function previewImage(preview, file) {
        let newFile = {
            id: Math.random(),
            preview,
            file,
            progress: 0,
            complete: false,
            done: false,
            disappear: false,
            cancel: null,
            errors: null
        }
        setFiles(files => [
            ...files,
            newFile
        ])

        let toRemove = Pl.add((done, file) => {
            uploadImage(token, file, props.kind, progress => {
                setFiles(files => {
                    let inx = files.indexOf(newFile)
                    if(inx < 0) return files;
                    files[inx].progress = progress
                    return [
                        ...files
                    ]
                })
            }, cancel => {
                setFiles(files => {
                    let inx = files.indexOf(newFile)
                    if(inx < 0) return files;
                    files[inx].cancel = cancel
                    return [
                        ...files
                    ]
                })
            })
            .then(resp => {
                done()
                if(!resp) {
                    spliceFiles(file)
                    return
                }
                
                if(resp.errors) {
                    setFiles(files => {
                        let inx = files.indexOf(newFile)
                        if(inx < 0) return files;
                        files[inx].errors = resp.errors[0].message
                        return [
                            ...files
                        ]
                    })
                } else {
    
                    setFiles(files => {
                        let inx = files.indexOf(newFile)
                        if(inx < 0) return files;
                        files[inx].complete = true
                        return [
                            ...files
                        ]
                    })
    
                    setTimeout(()=>{
                        setFiles(files => {
                            let inx = files.indexOf(newFile)
                            if(inx < 0) return files;
                            files[inx].done = files[inx].complete ? true : false  

                            setTimeout(() => {
                                spliceFiles(files[inx])
                            }, 500)

                            return [
                                ...files
                            ]
                        })

                    }, 1500)
                }
            })
        }, file)

        setFiles(files => {
            let inx = files.indexOf(newFile)
            files[inx].inList = toRemove
            return [
                ...files
            ]
        })
        
    }

    function handleImages(images) {
        for (var i = 0; i < images.length; i++) {
            var file = images[i];
            if(image.isImage(file)) {
                image.preview(file, previewImage)
            }
        }
    }
    
    function handleRemovePost(file) {
        if(file.cancel) {
            file.cancel()
        }

        if(file.inList) {
            file.inList.remove()
        }

        spliceFiles(file)

    }

    function spliceFiles (file) {
        setFiles(files => {
            let inx = files.indexOf(file)
            files.splice(inx, 1)
            return [
                ...files
            ]
        })
    }

    const showFiles = files.filter(file => !file.disappear).length

    return (
        <div style={{ width: '100%', float: 'left' }}>
            {props.logged ? (
                <ImageDropArea theme='primary' style={{borderRadius: '0'}} files={ (files)=> { handleImages(files) } }  />
            ) : 
                <Col className={css.loginBox} style={{...props.style}}>
                    <Col size='12' className={css.icon}>
                        <FontIcon size={38} name='camera' color={'#fff'}/>
                    </Col>
                    <Col size='12' className={css.msgDefault}>
                        {T.txt('login_images')}
                    </Col>
                    <Col size='12'>
                        <Button secondaryOutline inline onClick={() => props.handleSignup()}>{T.text('upload_my_photos')}</Button>
                    </Col>
                </Col>
            }
            <Col className={css.previewBox} style={{display: showFiles === 0 ? 'none' : ''}} size='12'>
                {files.map(file => (
                    <div key={file.id} className={file.done ? css.disappear : ''} style={{ opacity: '1', display: file.disappear ? "none" : "" }}>
                        <Row style={{marginBottom: '10px'}} alignItems='center'>
                            <Col size='2'>
                                <AspectRatio background={file.preview} />
                            </Col>
                            <Col className={css.previewName} size='8'>
                                <Font style={{whiteSpace: 'nowrap'}}>{file.file.name}</Font>
                                <ProgressBar progress={file.progress} height={file.complete || file.errors ? '0' : '5px'} />
                                <Font color='#ff0000' size='10' style={{whiteSpace: 'nowrap', display: file.errors ? '' : 'none'}}>{file.errors}</Font>
                            </Col>
                            <Col flex size='2'>
                                <FontIcon size={file.complete ? 20 : 10} style={{cursor: file.complete ? 'default' : 'pointer'}} onClick={() => handleRemovePost(file)} color={file.complete ? '#A3BD31' : 'inherit'} name={file.complete ? 'check' : 'close'} />
                            </Col>
                        </Row>
                    </div>
                ))}
            </Col>
        </div>
    )

}

export default UploadImages


// WEBPACK FOOTER //
// ./src/SPRINTA/v2/organisms/UploadImages/index.js